export default "__VITE_ASSET__BH16JPLJ__"